@if (userIsCustomer) {
  <div class="tabs dashboard-component-tabs is-boxed is-small is-marginless">
    <ul>
      <li class="is-active">
        <a><span i18n>Photos</span></a>
      </li>
    </ul>
  </div>
}

@if (plotIds.length >= 1) {
  @if (photoData && photoData.length > 0) {
      <div class="gallery sfb-content">
        <ng-template
          *ngTemplateOutlet="photoTemplate; context: {photo : activePhoto, photos: photoData} ">
        </ng-template>
      </div>
    } @else {
      <div class="content-placeholder"><span i18n>No photo data available.</span></div>
    }
} @else {
  <div class="content-placeholder" i18n>No plot selected.</div>
}

<ng-template #photoTemplate let-photos="photos" let-photo="photo">
  <div class="gallery">
    <div class="gallery-items">
      <div class="leftcol" #leftcol>

        <!--
        <swiper class="swiper" [keyboard]="true" [pagination]="true" [scrollbar]="true" [zoom]="true" [navigation]="true"
          *ngIf="photos && photos.length > 0" (swiper)="onSwiper($event)"
          (slideChangeTransitionEnd)="onSlideChange(type, $event)">
          <ng-template swiperSlide *ngFor="let slide of photos; let i = index">
            <img src="{{ slide.imageId | authImage: true | async }}"
              [ngClass]="{'rotated-clockwise': rotated === 90, 'rotated-counter-clockwise': rotated === 270, 'flipped': rotated === 180}"
              (click)="togglePreview(type, true)">
          </ng-template>
        </swiper>
        -->

        @if (photos && photos.length > 0) {
          <swiper-container appSwiper class="swiper " [config]="swiperOptions" (slideChange)="onSlideChange($event)">

              @for (slide of photos; track slide; let i = $index) {
                
                <swiper-slide >
                  <img src="{{ slide.imageId | authImage: true:0 | async }}"
                    [ngClass]="{'standard': rotated === 0, 'rotated-clockwise': rotated === 90, 'rotated-counter-clockwise': rotated === 270, 'flipped': rotated === 180, 'rotated-back': rotated === 360}"
                    (dblclick)="togglePreview(true)">

                  @if (!userIsCustomer) {
                    @if (photo.usable) {
                      <button class="button is-success is-small btn-topright" (click)="setUsable(photo)">
                        <span class="icon is-small">
                          <i-feather name="check" class="icon-smaller"></i-feather>
                        </span>
                        <strong i18n>Will be delivered</strong>
                      </button>
                    } @else {
                      <button class="button is-danger is-small btn-topright" (click)="setUsable(photo)">
                        <span class="icon is-small">
                          <i-feather name="x" class="icon-smaller"></i-feather>
                        </span>
                        <strong i18n>Will not be delivered</strong>
                      </button>
                    }
                  }
                </swiper-slide>
              }

          </swiper-container>
        }

        <div class="buttons has-addons is-centered no-bottom-margin">
          <button class="button is-light is-small" (click)="rotatePhoto(90)">
            <strong i18n>Rotate</strong>
            <span class="icon is-small">
              <i-feather name="rotate-cw" class="icon-smaller"></i-feather>
            </span>
          </button>

          <button class="button is-light is-small" (click)="rotatePhoto(180)">
            <strong i18n>Flip</strong>
            <span class="icon is-small">
              <i-feather name="refresh-cw" class="icon-smaller"></i-feather>
            </span>
          </button>

          <button class="button is-light is-small" (click)="rotatePhoto(270)">
            <strong i18n>Rotate</strong>
            <span class="icon is-small">
              <i-feather name="rotate-ccw" class="icon-smaller"></i-feather>
            </span>
          </button>

          <button class="button is-light is-small" (click)="rotatePhoto(360)">
            <strong i18n>Reset</strong>
            <span class="icon is-small">
              <i-feather name="stop-circle" class="icon-smaller"></i-feather>
            </span>
          </button>

        </div>

      </div>

      <div class="rightcol" #rightcol>
        <div class="columns">
          <div class="column has-text-weight-semibold">
            <span class="tag is-white is-medium" i18n>Photo Details</span>
          </div>
          <div class="column has-text-weight-semibold has-text-right">
            @if (photo.source === 'SFB') {
              <span class="tag sfb-color is-medium">sFB</span>
            } @else {
              <span class="tag ast-color is-medium">AST-Foto</span>
            }
          </div>
        </div>
        @if (photo) {
          <table class="table is-fullwidth table-compact overflow-breaking">
            <tbody>
              <tr>
                <th colspan="1"><span i18n>Plot ID</span></th>
                <td class="has-text-right">{{photo.schlag}}</td>
              </tr>
              <tr>
                <th colspan="1"><span i18n>Source</span></th>
                <td class="has-text-right">{{photo.source}}</td>
              </tr>
              <tr>
                <th colspan="1"><span i18n>Operator</span></th>
                @if (photo.source === 'SFB') {
                  <td class="has-text-right">{{photo.operator}}</td>
                } @else {
                  <td class="has-text-right" i18n>Applicant</td>
                }
              </tr>
              <tr>
                <th colspan="1"><span i18n>Detail</span></th>
                <td class="has-text-right" [innerHTML]="photo.detail | boolean"></td>
              </tr>
              <tr>
                <th colspan="1"><span i18n>Record date</span></th>
                <td class="has-text-right">{{photo.recordDate | date:'short':'+0200':'de'}}</td>
              </tr>
              <tr>
                <th colspan="1"><span i18n>Upload date</span></th>
                <td class="has-text-right">{{photo.uploadDate | date:'short':'+0200':'de'}}</td>
              </tr>
            </tbody>
          </table>
        }

        @if (!userIsCustomer) {
          <div>
            @if ((getResult(photo.results, 'CROPANALYZER_MONOCULTURES') || getResult(photo.results, 'CROPANALYZER_24')
              || getResult(photo.results, 'CROPANALYZER_MIXEDCROPS') || getResult(photo.results, 'CROPANALYZER_FALLOW')
              || getResult(photo.results, 'CROPANALYZER_GRASS') || getResult(photo.results, 'FLORAINCOGNITA'))) {
              <table
                class="table is-bordered bottom-border is-fullwidth table-compact overflow-breaking">
                <tbody>
                  @if (getResult(photo.results, 'CROPANALYZER_MONOCULTURES'); as result;) {
                    <tr>
                      <ng-template *ngTemplateOutlet="resultTemplate; context: {result : result, grass: false}"></ng-template>
                    </tr>
                  }
                  @if (getResult(photo.results, 'CROPANALYZER_24'); as result;) {
                    <tr>
                      <ng-template *ngTemplateOutlet="resultTemplate; context: {result : result, grass: false}"></ng-template>
                    </tr>
                  }
                  @if (getResult(photo.results, 'CROPANALYZER_MIXEDCROPS'); as result;) {
                    <tr>
                      <ng-template *ngTemplateOutlet="resultTemplate; context: {result : result, grass: false}"></ng-template>
                    </tr>
                  }
                  @if (getResult(photo.results, 'CROPANALYZER_FALLOW') &&
                    (getResult(photo.results, 'CROPANALYZER_MONOCULTURES') || getResult(photo.results, 'CROPANALYZER_24')
                    || getResult(photo.results, 'CROPANALYZER_MIXEDCROPS'))) {
                    <tr class="blank_row">
                      <td colspan="5"></td>
                    </tr>
                  }
                  @if (getResult(photo.results, 'CROPANALYZER_FALLOW'); as result;) {
                    <tr>
                      <ng-template *ngTemplateOutlet="resultTemplate; context: {result : result, grass: false}"></ng-template>
                    </tr>
                  }
                  @if ((getResult(photo.results, 'CROPANALYZER_FALLOW') ||
                    (getResult(photo.results, 'CROPANALYZER_MONOCULTURES') || getResult(photo.results, 'CROPANALYZER_24')
                    || getResult(photo.results, 'CROPANALYZER_MIXEDCROPS'))) && getResult(photo.results, 'CROPANALYZER_GRASS')) {
                    <tr class="blank_row">
                      <td colspan="5"></td>
                    </tr>
                  }
                  @if (getResult(photo.results, 'CROPANALYZER_GRASS'); as result;) {
                    <tr >
                      <ng-template *ngTemplateOutlet="resultTemplate; context: {result : result, grass: true}"></ng-template>
                    </tr>
                  }
                  @if ((getResult(photo.results, 'CROPANALYZER_FALLOW') ||
                    (getResult(photo.results, 'CROPANALYZER_MONOCULTURES') || getResult(photo.results, 'CROPANALYZER_24')
                    || getResult(photo.results, 'CROPANALYZER_MIXEDCROPS')) || getResult(photo.results, 'CROPANALYZER_GRASS')) && getResult(photo.results, 'FLORAINCOGNITA')) {
                    <tr class="blank_row">
                      <td colspan="5"></td>
                    </tr>
                  }
                  @if (getResult(photo.results, 'FLORAINCOGNITA'); as result;) {
                    <tr>
                      <ng-template *ngTemplateOutlet="resultTemplate; context: {result : result, grass: false}"></ng-template>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </div>
        } @else {
          @if (getResult(photo.results, 'FLORAINCOGNITA'); as result;) {
            <table
              class="table is-bordered bottom-border is-fullwidth table-compact overflow-breaking">
              <tbody>
                <tr>
                  <ng-template *ngTemplateOutlet="resultTemplate; context: {result : result, grass: false}"></ng-template>
                </tr>
              </tbody>
            </table>
          }
        }


        <ng-template #resultTemplate let-result="result" let-grass="grass">
          <th colspan="2">
            {{ getClassificationTranslation(result.method) }}
          </th>
          @if (result.predictClass) {
            <td class="has-text-centered"
            [ngClass]="getlwtColor(result.predictClass, grass)" >{{ getClassificationTranslation(result.predictClass)}}</td>
          } @else {
            <td class="has-text-centered"><i i18n>Processing...</i></td>
            <td class="has-text-right fixed-width"></td>
          }
          @if (result.predictClass) {
            <td class="has-text-right fixed-width"
            [ngClass]="getPercentageColor(result.perc)">{{result.perc * 100 | number :'1.0-2'}}%</td>
          }
        </ng-template>

      </div>
    </div>
  </div>
</ng-template>

@if (showImageModal) {
  <app-image-modal [photoData]="photoData" [slide]="currentSlideIndex"
  (onClose)="togglePreview(false)"></app-image-modal>
}

